import IManufacturer from './interfaces/manufacturer.d';
import IImageCollectionSearchModel from '../image/interfaces/image-collection-search-model.d';

export default class Manufacturer implements IManufacturer {
  public externalReferenceTypeId!: number;

  public externalReferenceTypeName!: string;

  public manufacturerExternalReferenceId!: string;

  public manufacturerNameSlug!: string;

  public active!: boolean;

  public fuelTypes!: string[];

  public bodystyles!: string[];

  public manufacturerId!: number;

  public manufacturerName: string = '';

  public imageId!: number;

  public images!: IImageCollectionSearchModel;
}
